"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var content_section_1 = __importDefault(require("./content.section"));
var index_1 = __importDefault(require("../../landing/fans/sections/getStarted/index"));
var hero_module_1 = __importDefault(require("../../../modules/hero/hero.module"));
var i18next_1 = require("i18next");
function Music() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hero_module_1.default, { style: {
                    backgroundImage: "url(\"/assets/images/collectibles/bgmusic2.png\")",
                }, title: (0, i18next_1.t)("collectibleMusic.title") }), (0, jsx_runtime_1.jsx)(content_section_1.default, {}), (0, jsx_runtime_1.jsx)(index_1.default, {})] }));
}
exports.default = Music;
